import { useEffect } from 'react';
import type { Translations, Lang } from '../types';

export function useSEO(t: Translations, lang: Lang) {
  useEffect(() => {
    if (!t || Object.keys(t).length === 0) return;

    // Aktualizacja języka w tagu <html>
    document.documentElement.lang = lang;
    
    // 1. Tytuł strony (Zakładka)
    document.title = t.seo_title || t.page_title || 'Prestige Care';

    // Helper do aktualizacji tagów meta
    const updateMeta = (name: string, content: string, isProperty = false) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let tag = document.querySelector(selector);
      
      if (!tag) {
        tag = document.createElement('meta');
        if (isProperty) tag.setAttribute('property', name);
        else tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content || '');
    };

    // 2. Podstawowe Meta Tagi (z bazy danych)
    updateMeta('description', t.seo_desc || t.meta_desc);
    updateMeta('keywords', t.seo_keywords || t.meta_keywords);
    updateMeta('og:title', t.seo_title || t.og_title, true);
    updateMeta('og:description', t.seo_desc || t.og_desc, true);
    updateMeta('og:locale', lang === 'de' ? 'de_DE' : 'pl_PL', true);

    // 3. SEO BONUS: Tag Canonical (Chroni przed duplikacją treści)
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://prestige-care.de/');

    // 4. SEO BONUS: Hreflang (Wielojęzyczność dla Google)
    const updateHreflang = (langCode: string) => {
      let hreflang = document.querySelector(`link[hreflang="${langCode}"]`);
      if (!hreflang) {
        hreflang = document.createElement('link');
        hreflang.setAttribute('rel', 'alternate');
        hreflang.setAttribute('hreflang', langCode);
        document.head.appendChild(hreflang);
      }
      hreflang.setAttribute('href', `https://prestige-care.de/`);
    };
    updateHreflang('de');
    updateHreflang('pl');
    updateHreflang('x-default'); // Wskazuje główny język dla reszty świata

    // 5. CZYSTY Schema.org (JSON-LD) - bez psujących tagów <p> i <a>
    let schemaTag = document.getElementById('schema-org');
    if (!schemaTag) {
      schemaTag = document.createElement('script');
      schemaTag.id = 'schema-org';
      schemaTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(schemaTag);
    }

    const schemaData = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": t.company_name || "Prestige Care",
      "image": "https://prestige-care.de/logo.webp",
      "telephone": t.company_phone || "+49 1577 4433774",
      "email": t.company_email || "info@prestige-care.de",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": t.company_city || "Edesheim",
        "postalCode": t.company_zip || "67483",
        "addressCountry": "DE"
      },
      "url": "https://prestige-care.de/"
    };

    schemaTag.innerHTML = JSON.stringify(schemaData);

  }, [t, lang]);
}